import React, { useState } from 'react'
import { Emoji } from 'emoji-mart'
import EmojiSelector from 'components/EmojiSelector'


/**
 * Render button for emoji
 * @param {object} props
 * @param {function} props.onClick
 * @param {string} props.emoji
 * @param {boolean} [props.isActive]
 * @param {string} [props.className]
 */
export const EmojiButton = (props) => {
  const { emoji, onClick, isActive, className } = props

  let classname = 'feed-reactions-emoji__favs--emoji'
  if (isActive) classname += ' feed-reactions-emoji__favs--selected'
  if (className) classname += ` ${className}`

  return (
    <div
      onClick={() => onClick(emoji)}
      className={classname}
    >
      <Emoji
        emoji={emoji}
        set='apple'
        size={13}
        fallback={(emoji, props) => {
          if (props.emoji === '❤') return '❤️'

          return emoji ? `:${emoji.short_names[0]}:` : props.emoji
        }}
      />
    </div>
  )
}

/**
 * Render emoji options
 * @param {object} props
 * @param {function} props.onClick
 */
export const EmojiOptions = (props) => {
  const { onClick } = props

  const [open, setOpen] = useState(false)

  return (
    <div>
      <EmojiButton
        onClick={() => setOpen(!open)}
        emoji='➕'
        className='feed-reactions-emoji__favs--emoji_options'
      />
      <EmojiSelector
        showEmojis={open}
        handleToggle={() => setOpen(!open)}
        handleSelect={(emoji) => onClick(emoji.native)}
      />
    </div>
  )
}